import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import { Helmet } from "react-helmet-async";

const serviceItems = [
    {
        id: 1,
        title: "Detect issues early with predictive insights ",
        description: "Drive revenue and loyalty through consistent, proactive service engagement across all critical touchpoints.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Reduce alert noise through intelligent correlation",
        description: "Gain complete and unified visibility across end-to-end employee and customer journeys without data silos.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Improve reliability across hybrid and cloud environments ",
        description: "Significantly cut operational service overheads with intelligent automation and streamlined digital workflows.",
        image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 4,
        title: "Accelerate resolution with automated workflows",
        description: "Accelerate business agility with rapid deployment and seamless rollout of modern digital services.",
        image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 5,
        title: "Gain end-to-end visibility across critical services ",
        description: "Extract maximum return on investment and business value from enterprise platforms like ServiceNow.",
        image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 6,
        title: "Build a scalable foundation for future operations ",
        description: "Extract maximum return on investment and business value from enterprise platforms like ServiceNow.",
        image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1000&q=80"
    },
];

const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Innovation and AI",
        desc: "Accelerate innovation with AI-driven platforms, scalable digital foundations, and new workflows that unlock growth and future-ready transformation.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "Operational Visibility and Service Foundation",
        desc: "Create a unified view across infrastructure, applications, and services. Connect operational data to business impact and improve service awareness.",
        products: ["CMDB", "Service Mapping", "Observability Foundations"]
    },
    {
        id: 2,
        title: "Operations and Management:",
        desc: "Modernize IT operations with connected workflows across monitoring, discovery, and service health. Improve control, reduce blind spots, and standardize operational response.",
        products: ["Discovery", "Service Health", "Event Management"]
    },
    {
        id: 3,
        title: "AI-Powered Ops",
        desc: "Use AI-driven insights and automation to prevent disruptions and reduce manual effort. Improve speed, consistency, and operational maturity.",
        products: ["AI Ops", "Predictive Intelligence"]
    }
];


const industryTabs = [
    {
        id: "manufacturing",
        label: "Manufacturing",
        title: "Manufacturing",
        desc: "We improve uptime across plants, assets, and frontline operations with proactive service health and automation.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "bfsi",
        label: "BFSI",
        title: "BFSI",
        desc: "Delivering resilient, compliant operations with stronger governance and reliable service performance.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "retail",
        label: "Retail",
        title: "Retail",
        desc: "We support smooth operations across stores, supply chains, and digital service environments.",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "telecom",
        label: "Telecommunication",
        title: "Telecommunication",
        desc: "We help you streamline high-volume environments with intelligent monitoring and faster resolution workflows.",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "Cross-Enterprise Operational Control",
        desc: "We unify infrastructure health, service performance, and business impact into one model."
    },
    {
        id: 2,
        title: "AI-First Operational Approach",
        desc: "We embed intelligence and automation to prevent issues before they disrupt operations."
    },
    {
        id: 3,
        title: "Integration and Speed to Value",
        desc: "We connect systems, tools, and teams into one operational foundation with rapid implementation."
    },
    {
        id: 4,
        title: "Designed for Hybrid and Multi-Cloud Environments",
        desc: "We help enterprises manage complex environments across on-prem, cloud, and distributed infrastructure."
    }
];


const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];
const faqData = [
    {
        id: 1,
        question: "How do Intelligent Operations enable a shift from reactive to proactive?",
        answer: "Intelligent Operations use real-time data, AI, and predictive insights to detect issues before they escalate, enabling teams to prevent incidents rather than just respond to them."
    },
    {
        id: 2,
        question: "What challenges do Intelligent Operations solve in hybrid environments?",
        answer: "They eliminate operational silos, provide unified visibility across fragmented on-premise and multi-cloud systems, and reduce complexity by standardizing monitoring, discovery, and governance workflows."
    },
    {
        id: 3,
        question: "How does AIOps improve service reliability?",
        answer: "AIOps correlates massive volumes of telemetry and event data, reduces alert noise, pinpoints root causes automatically, and initiates proactive remediation before outages impact end-users."
    },
    {
        id: 4,
        question: "What role does automation play in Intelligent Operations?",
        answer: "Automation handles repetitive operational tasks, orchestrates cross-platform incident responses, standardizes change management, and enables self-healing system capabilities to minimize manual effort."
    },
    {
        id: 5,
        question: "Is Intelligent Operations suitable for hybrid and multi-cloud environments?",
        answer: "Yes, it is purposefully engineered to manage distributed, hybrid, and multi-cloud architectures by connecting heterogeneous tools and infrastructure into a centralized operational control model."
    },
    {
        id: 6,
        question: "When should an organization adopt Intelligent Operations?",
        answer: "Organizations should adopt Intelligent Operations when expanding infrastructure complexity, persistent alert fatigue, high incident resolution times, or lack of cross-service visibility begin impacting business growth."
    }
];



function IntelligentOperations() {
    return (
        <div>
             <Helmet>

                {/* Primary SEO */}
                <title>
                    Intelligent Operations & AIOps Solutions | Mobikode
                </title>

                <meta
                    name="description"
                    content="Transform IT operations with Mobikode Intelligent Operations and AIOps solutions. Improve service reliability with predictive insights, intelligent automation, real-time visibility, event management, and hybrid cloud operations."
                />

                <meta
                    name="keywords"
                    content="Intelligent Operations, AIOps Solutions, AIOps Consulting, ServiceNow AIOps, ServiceNow ITOM, ServiceNow Operations, ServiceNow Event Management, ServiceNow Discovery, ServiceNow Service Mapping, predictive intelligence, IT operations automation, ITOM solutions, hybrid cloud operations, multi-cloud operations, intelligent IT operations, IT operations management, ServiceNow consulting"
                />

                {/* Indexing */}
                <meta
                    name="robots"
                    content="index, follow, max-image-preview:large"
                />

                <meta
                    name="googlebot"
                    content="index, follow"
                />

                {/* Canonical */}
                <link
                    rel="canonical"
                    href="https://www.mobikode.com/intelligent-operations"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Intelligent Operations & AIOps Solutions | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Run proactive, reliable IT operations with Mobikode's Intelligent Operations and AIOps solutions powered by predictive insights, automation, monitoring, and unified visibility."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/intelligent-operations"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Mobikode"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/glodesk/bg2.png"
                />

                <meta
                    property="og:image:alt"
                    content="Mobikode Intelligent Operations and AIOps Solutions"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Intelligent Operations & AIOps Solutions | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Improve IT operations with AIOps, predictive intelligence, automation, event management, discovery, service mapping, and hybrid cloud visibility."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/glodesk/bg2.png"
                />

                {/* Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Intelligent Operations & AIOps Solutions",
                        "serviceType": "Intelligent Operations",
                        "description":
                            "Mobikode provides Intelligent Operations and AIOps solutions that help enterprises improve IT operations through predictive insights, intelligent automation, real-time visibility, event management, discovery, service mapping, and hybrid cloud operations.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Mobikode",
                            "url": "https://www.mobikode.com/"
                        },
                        "areaServed": {
                            "@type": "Place",
                            "name": "Worldwide"
                        },
                        "url":
                            "https://www.mobikode.com/intelligent-operations"
                    })}
                </script>

            </Helmet>
            <WhoHero
                title="For AI-Driven Ops "
                text="Run stronger, more reliable operations with real-time visibility, automation, and proactive issue prevention with Intelligent operations "
                imgData="/assets/glodesk/bg2.png"
            />
            <UserFirstExperienceSection title="Move from Reactive Ops to Proactive Control with Intelligent Operations" description="Operations have become more complex across hybrid environments, disconnected tools, and rising service expectations. Many teams still spend too much time reacting to incidents instead of preventing them. That is why we created Intelligent Operations, an expert-led capability designed to help organizations shift to proactive, AI-powered operational control and deliver consistent business continuity." />
            <ServiceX360ViewSection title="Achieve Always-On Operational Excellence" description="Intelligent Operations helps enterprises improve service health, infrastructure performance, and operational response. With unified visibility and AIOps, you can:" serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our Full-Suite of Intelligent Operations Offerings" description="With Intelligent Operations, Mobikode helps enterprises run proactive, reliable operations across infrastructure, services, and business-critical environments." />
            <IndustriesServiceExperienceSection title="Transforming Service Experiences Across Industries" industryTabs={industryTabs} />
            <WhatSetsApartSection title="Mobikode for Intelligent Operations" description="Our deep expertise across experience transformation, workflow design, and enterprise service delivery helps organizations realize faster adoption and measurable outcomes with ServiceX." apartData={apartData} />
            <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} />
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default IntelligentOperations
